<template>
    <Layout is-crm :content-class="'content--narrow'">
        <div class="container">
            <Spinner v-if="loading" />
            <UsersRepeater
                v-if="!loading && Object.keys(schema).length"
                :schema="schema"
                :languages="languages"
                :loading="loading"
                :error="error"
                trigger-text="crm.customers.members.repeater.trigger"
                @cancel="cancel"
                @save="save"
            >
                <template #header>
                    <Grid>
                        <Column :span="6">
                            <h3 v-text="$t('crm.customers.members.add.title')"></h3>
                        </Column>
                        <Column :span="6">
                            <FormField
                                v-if="isInnerWorkspace"
                                name="customer"
                                :label="schema.customer.label"
                                :required="schema.customer.required"
                                :error="error"
                            >
                                <CustomSelect
                                    v-model="customerId"
                                    emit-prop="id"
                                    view-label="name"
                                    :options="customers"
                                    clearable
                                />
                            </FormField>
                        </Column>
                    </Grid>
                </template>
            </UsersRepeater>
        </div>
    </Layout>
</template>

<script>
import { createCustomersMembers, fetchCustomersMembersLanguages } from '../../api/customers';
import { CustomSelect, FormField } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { UsersRepeater } from '../../../users/components';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'CustomersMembersCreatePage',
    components: {
        CustomSelect,
        FormField,
        Grid,
        Column,
        Layout,
        Spinner,
        UsersRepeater,
    },
    data() {
        return {
            loading: false,
            error: undefined,
            customerId: undefined,
            languages: undefined,
        };
    },
    computed: {
        ...mapState('customer', ['customers']),
        ...mapState('customersMember', ['authMember']),
        ...mapGetters('workspaces', ['isInnerWorkspace', 'workspaceCustomerId']),

        userId() {
            const { user } = this.$store.state.auth;
            return user.pk;
        },
        schema() {
            const { schema = {} } = this.$store.state.customersMember;
            return schema.create_users || {};
        },
    },
    watch: {
        workspaceCustomerId: {
            immediate: true,
            handler(customer) {
                console.log('hello', customer);
                this.customerId = customer;
            },
        },
    },
    async created() {
        this.loading = true;

        try {
            await Promise.all([this.fetchSchema(), this.fetchCustomers(), this.fetchLanguages()]);
        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions('customer', ['fetchCustomers']),
        ...mapActions('customersMember', ['fetchSchema']),

        cancel() {
            this.$router.push({ name: 'customers-members' });
        },
        async fetchLanguages() {
            this.loading = true;

            try {
                this.languages = await fetchCustomersMembersLanguages();
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        async save({ users }) {
            this.loading = true;

            const data = {
                customer: this.customerId,
                users,
            };

            try {
                await createCustomersMembers(data);
                this.$router.push({
                    name: 'customers-members',
                });
            } catch (e) {
                this.error = e;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" src="./CustomersMembersCreatePage.scss"></style>
